/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Directory_Resources_Affiliates_StepsInputs */

const en_directory_resources_affiliates_steps = /** @type {(inputs: Directory_Resources_Affiliates_StepsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Share your audience|Explain your channel|Ask about eligibility`)
};

const zh_directory_resources_affiliates_steps = /** @type {(inputs: Directory_Resources_Affiliates_StepsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`介绍你的受众|说明你的渠道|咨询参与资格`)
};

/**
* | output |
* | --- |
* | "Share your audience\|Explain your channel\|Ask about eligibility" |
*
* @param {Directory_Resources_Affiliates_StepsInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const directory_resources_affiliates_steps = /** @type {((inputs?: Directory_Resources_Affiliates_StepsInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Directory_Resources_Affiliates_StepsInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_directory_resources_affiliates_steps(inputs)
	return zh_directory_resources_affiliates_steps(inputs)
});
export { directory_resources_affiliates_steps as "directory.resources.affiliates.steps" }